export default __webpack_public_path__ + "static/media/Steelspirit Boots.a8b7855e.jpg";